import { render, staticRenderFns } from "./AdressListItem.vue?vue&type=template&id=badf88c2&scoped=true&"
import script from "./AdressListItem.vue?vue&type=script&lang=js&"
export * from "./AdressListItem.vue?vue&type=script&lang=js&"
import style0 from "./AdressListItem.vue?vue&type=style&index=0&id=badf88c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badf88c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VTextField})
